import type { BenefitSummary, ListItem } from "@yutai/shared"
import { useMemo } from "react"
import { BenefitCardsSection } from "../benefit/BenefitCardsSection.js"
import sectionStyles from "../benefit/BenefitCardsSection.module.css"
import { findRecommendedBenefitsForList } from "../benefit/findRecommendedBenefits.js"

interface Props {
  listItems: ListItem[]
  isHoldingMode: boolean
  allBenefits: BenefitSummary[]
}

export function RecommendedBenefitsSection({ listItems, isHoldingMode, allBenefits }: Props) {
  const recommended = useMemo(
    () => findRecommendedBenefitsForList(listItems, isHoldingMode, allBenefits),
    [listItems, isHoldingMode, allBenefits]
  )

  return (
    <BenefitCardsSection
      sectionId="recommended-benefits-title"
      title="おすすめの銘柄"
      lead="このリストの銘柄に似た優待内容・投資規模の銘柄です。"
      benefits={recommended.map((item) => item.benefit)}
      cardBorderVariant="gradient"
      className={sectionStyles.sectionSpacing}
    />
  )
}
